/** @format */

const template = `
<input
  class="form-control"
  lang="fi"
  type="number"
  min="0"
  max="100"
  ng-change="update()"
  ng-model="ngModel.$viewValue"
  valdr-no-validate="true" />
`;
export default template;
